<tt-page *ngIf="!!edit">
    <a href="" [id]="linkId"></a>

    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="invoice_no" [ttModel]="edit.invoice_no" ttReadonly></tt-input>
        <tt-textarea ttLabel="ehf_content" [ttModel]="edit.ehf_content ?? ''" ttReadonly></tt-textarea>
        <tt-button ttText="invoiceheadehf_create" (ttClick)="createEhfFile()" [ttSpin]="creatingEhf" ttIcon="fa fa-paper-plane" ttType="success"></tt-button>
        <tt-button-save [hidden]="edit.ehf_content === ''" ttText="invoiceheadehf_save_to_file" (ttClick)="saveToFile()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
